import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
    const currentYear = new Date().getFullYear(); // Get the current year
    const navigate = useNavigate();

   
    return (
        <footer>
            <div className="container">
                <div className="card company-info">
                    <p>© Copyright Grassroots360 {currentYear}, all rights reserved.</p>
                    <p>Registered Company No: <b>16165252</b></p>
                </div>
                <div className="card">
                    <h5>Privacy &amp; Terms of Service</h5>
                    <p><button onClick={() => navigate('/terms-of-service')}>Terms of Service</button></p>
                    <p><button onClick={() => navigate('/privacy-policy')}>Privacy Policy</button></p>
                    <p><button onClick={() => navigate('/delete-account')}>Delete My Account</button></p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
